import { Box, Tooltip } from '@mui/material';

export interface FitScoreProps {
  score: number;
  reason?: string;
  isThesisFit?: boolean;
}

enum FitScoreReason {
  'Poor Fit' = 1,
  'Weak Fit' = 2,
  'Moderate Fit' = 3,
  'Strong Fit' = 4,
  'Exceptional Fit' = 5,
}
export function FitScore({ score, reason, isThesisFit = false }: FitScoreProps) {
  const maxScore = 5;

  return (
    <Tooltip title={reason}>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
          {Array.from({ length: maxScore }, (_, index) => (
            <Box key={index}>{Dot(index < score)}</Box>
          ))}
        </Box>
      </Box>
    </Tooltip>
  );
}

function Dot(active: boolean) {
  const dotStyles = {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
  };

  return (
    <Box
      data-testid={active ? 'FitScore-dot-active' : 'FitScore-dot-inactive'}
      sx={{
        ...dotStyles,
        bgcolor: active ? 'primary.main' : 'secondary.main',
      }}
    ></Box>
  );
}

export default FitScore;
